import { render } from "./BatchesWaitingToReceive.vue?vue&type=template&id=961dc33e"
import script from "./BatchesWaitingToReceive.vue?vue&type=script&lang=js"
export * from "./BatchesWaitingToReceive.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__